import { render, staticRenderFns } from "./RiderAppSettings.vue?vue&type=template&id=3b006686&scoped=true"
import script from "./RiderAppSettings.vue?vue&type=script&lang=js"
export * from "./RiderAppSettings.vue?vue&type=script&lang=js"
import style0 from "./RiderAppSettings.vue?vue&type=style&index=0&id=3b006686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b006686",
  null
  
)

export default component.exports